import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineCancelModal のスタイル
 */
export const hotlineCancelModalStyle = tv({
    slots: {
        base: [],
        button: ['sm:max-[200px]'],
        buttonWrap: ['flex flex-col sm:flex-row-reverse justify-center gap-16'],
        cancelUserList: [
            'px-12',
            'divide-x-0 divide-y divide-gray-100 divide-solid',
        ],
        cancelUserListItems: ['py-12 first:pt-8 last:pb-8'],
        cancelUserListWrap: [
            'overflow-y-auto',
            'border border-solid border-gray-400',
            'max-h-[180px]',
        ],
        checkbox: ['mx-auto'],
        contentWrap: ['flex flex-col gap-20 md:gap-28'],
        descriptionContentWrap: ['flex flex-col item-center gap-8'],
        descriptionTitle: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        warningPointContent: [
            'flex flex-col gap-8',
            'bg-orange-50',
            'w-full',
            'p-16',
            'rounded-md',
        ],
        warningPointList: ['flex flex-col gap-8', 'list-disc', 'pl-[18px]'],
        warningPointListItem: [textStyle({ color: 'base', size: 'sm' })],
        warningText: [textStyle({ color: 'base', size: 'sm' })],
    },
    variants: {
        hasUserList: {
            false: {
                base: ['!max-w-[min(430px,100%)]'],
            },
            true: {
                base: ['!max-w-[min(526px,100%)]'],
            },
        },
    },
});
